export const CREATE_AFFILIATE_CLICK = 'affiliates/CREATE_AFFILIATE_CLICK'
export const CREATE_AFFILIATE_CLICK_STARTED =
  'affiliates/CREATE_AFFILIATE_CLICK_STARTED'
export const CREATE_AFFILIATE_CLICK_SUCCESS =
  'affiliates/CREATE_AFFILIATE_CLICK_SUCCESS'
export const CREATE_AFFILIATE_CLICK_FAILED =
  'affiliates/CREATE_AFFILIATE_CLICK_FAILED'

export const CLICK_ID_KEY = 'affiliate-click-id'
